import apiClient from '../apiClient';

export const getGlobalModelConfiguration = () => {
    return apiClient.get('/admin/model-configuration');
};

export const updateGlobalModelConfiguration = (data) => {
    return apiClient.put('/admin/model-configuration', data);
};

export const deleteGlobalModelConfiguration = () => {
    return apiClient.delete('/admin/model-configuration');
};

export const getAvailableModelsForConfiguration = () => {
    return apiClient.get('/admin/model-configuration/available-models');
};
